<template>
  <div>
    <div class="tabel-bar">
      <div class="tabel-bar-left">
        <el-button type="primary" v-if="addBtnShow" :size="$store.state.buttonSize" @click="batchPopup()"
          >新增批次</el-button
        >
        <RemoveButton
          type="info"
          :size="$store.state.buttonSize"
          @click="handleRemoveAll"
          :disabled="!selectionID.length"
          >批量删除</RemoveButton
        >
      </div>
      <div class="tabel-bar-right">
        <el-input
          placeholder="请输入内容"
          :size="$store.state.formSize"
          prefix-icon="el-icon-search"
          v-model="keywords"
          @input="search"
        ></el-input>
        <el-tooltip effect="dark" content="刷新列表" placement="bottom">
          <span
            class="el-icon-refresh icon-hover refresh-btn"
            @click="debounceRefresh"
          ></span>
        </el-tooltip>
      </div>
    </div>
    <el-table
      v-loading="loading"
      :data="tableData"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column prop="batchCode" label="批次编号"> </el-table-column>
      <el-table-column prop="barcode" label="条形码"> </el-table-column>
      <el-table-column prop="productName" label="产品名称"> </el-table-column>
      <el-table-column prop="productionDate" label="生产开始日期">
        <template slot-scope="scope">
          {{ scope.row.startDate | formatDate }}
        </template>
      </el-table-column>
      <el-table-column prop="endDate" label="生产结束日期">
        <template slot-scope="scope">
          {{ scope.row.endDate | formatDate }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="310">
        <template slot-scope="scope">
          <el-button type="text" @click="batchPopup(scope.row.id)"
            >编辑</el-button
          >
          <el-button type="text" @click="batchDel(scope.row.id)"
            >删除</el-button
          >
          <el-button type="text" @click="qrCodePopup(scope.row.id, scope.row.batchCode, scope.row.barcode)">二维码</el-button
          >
          <el-button type="text" @click="batchControlPoint(scope.row.id)">关键控制点</el-button
          >
          <el-button type="text" @click="batchCheckPoint(scope.row.id)">检验项</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-size="size"
      :total="total"
    >
    </pagination>
    <!-- 弹出层 -->
    <el-dialog
      :close-on-click-modal="false"
      :append-to-body="true"
      :title="title"
      :visible.sync="batchFormVisible"
      center
      width="50%"
    >
      <el-form
        :model="batchForm"
        :size="$store.state.formSize"
        :rules="batchFormRules"
        ref="refbatchForm"
        label-width="140px"
        style="padding-right: 30px;"
      >
        <el-form-item label="批次编号：" prop="batchCode">
          <el-input
            v-model="batchForm.batchCode"
            placeholder="请输入批次编号"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="产品名称：">
          <el-input
            v-model="batchForm.productName"
            :placeholder="batchForm.productName"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="数量：" prop="num">
          <el-input
            v-model="batchForm.num"
            :placeholder="batchForm.num"
          ></el-input>
        </el-form-item>
        <!-- <div v-for="(domain, index) in batchForm.domains" :key="domain.key"> -->
          <!-- <el-form-item
            label="产品名称："
            :prop="`domains.${index}.name`"
            :rules="{ required: true, message: '请选择产品', trigger: 'blur' }"
          >
            <div class="product-select-wrap">
              <el-select
                v-model="domain.name"
                style="width:100%;"
                filterable
                placeholder="请选择产品"
                @change="setProductNumber"
              >
                <el-option
                  v-for="productItem in productList"
                  :key="productItem.value"
                  :label="productItem.label"
                  :value="productItem.value"
                >
                </el-option>
              </el-select>
              <template v-if="isAdd">
                <i v-if="index === 0" class="product-select-icon el-icon-plus" @click="onAddDynamicForm"></i>
                <i v-else class="product-select-icon  el-icon-close" @click="onDelDynamicForm(index)"></i>
              </template>
            </div>
          </el-form-item> -->
          <!-- <el-form-item
            label="数量："
            :prop="`domains.${index}.number`"
            :rules="{ required: true, message: '请输入数量', trigger: 'blur' }"
          >
            <el-input
              v-model="domain.number"
              placeholder="请输入数量"
            ></el-input>
          </el-form-item> -->
        <!-- </div> -->
        <el-form-item label="负责人：" prop="manager">
          <el-input
            v-model="batchForm.manager"
          ></el-input>
        </el-form-item>
        <el-form-item label="生产开始日期：" prop="startDate">
          <el-date-picker
            v-model="batchForm.startDate"
            value-format="yyyy-MM-dd"
            autocomplete="off"
            type="date"
            style="width:100%"
            :placeholder="batchForm.startDate"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="生产结束日期：" prop="endDate">
          <el-date-picker
            v-model="batchForm.endDate"
            value-format="yyyy-MM-dd"
            autocomplete="off"
            type="date"
            style="width:100%"
            :placeholder="batchForm.endDate"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div class="text-center">
        <el-button
          type="primary"
          :size="$store.state.buttonSize"
          :disabled="isDisabled"
          @click="debounceSubmit"
          >确 定</el-button
        >
        <el-button :size="$store.state.buttonSize" @click="hanleResetFormVals">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 关键控制点弹出层 -->
    <Dialog
      title="关键控制点管理"
      :visible.sync="batchControlPointVisible"
      center
      width="80%"
    >
      <BatchControlPoint :batchId="batchId" :productId="productId" />
    </Dialog>
    <!-- 检查项弹出层 -->
    <Dialog
      title="检查项管理"
      :visible.sync="batchCheckVisible"
      center
      width="80%"
    >
      <BatchCheck :batchId="batchId" :productId="productId" />
    </Dialog>
    <!-- 二维码生成 -->
    <Dialog
      title="二维码"
      :visible.sync="qrCodePopupVisible"
      center
      width="80%"
    >
      <QrCodeController :batchId="batchId" :batchCode="batchCode" :barcode="barcode" />
    </Dialog>
  </div>
</template>
<script>
import moment from 'moment'
import { debounce } from 'throttle-debounce'
import {
  getBatchmanageProductList,
  delBatchmanageList,
  deleteBatchmanageDel,
  postBatchmanageEdit,
  putBatchmanageAdd,
  getBatchmanageDetail,
  getBatchmanageProduct
} from '@/api/batchmanage'
import { getProductList, getProductDetail } from '@/api/product'
import BatchControlPoint from './BatchControlPoint'
import BatchCheck from './BatchCheck'
import QrCodeController from './QrCodeController'

// const dynamicFirstKey = 'dynamicFirstKey'

const createForm = () => ({
  // *批次编号
  batchCode: '',
  // *生产开始/结束日期
  startDate: '',
  endDate: '',
  // *产品列表选择
  productId: null,
  // get productIds() {
  //   return form.domains.map(_ => _.name)
  // },
  // get nums() {
  //   return form.domains.map(_ => _.number)
  // },
  num: '0',
  productName: '',
  // *负责人
  manager: '',
  // *生产记录ID
  productionRecordId: null

  // domains: [{
  //   key: dynamicFirstKey,
  //   name: '',
  //   number: 0
  // }]
})

export default {
  components: {
    BatchControlPoint,
    BatchCheck,
    QrCodeController
  },
  data() {
    return {
      addBtnShow: false,
      selectionID: [],
      productList: [],
      batchFormVisible: false,
      batchControlPointVisible: false,
      qrCodePopupVisible: false,
      batchCheckVisible: false,
      isDisabled: false,
      total: 0,
      size: 10,
      page: 1,
      keywords: '',
      currentID: null,
      batchId: null,
      batchCode: null,
      barcode: null,
      loading: true,
      tableData: [],
      batchForm: createForm(),
      isShowBatchControlPoint: false,
      uid: 0,
      isAdd: false,
      batchFormRules: {
        startDate: [
          { required: true, message: '请选择生产开始日期', trigger: 'blur' }
        ],
        endDate: [
          { required: true, message: '请选择生产结束日期', trigger: 'blur' }
        ],
        batchCode: [
          { required: true, message: '请输入批次编号', trigger: 'blur' }
        ],
        productId: [
          { required: true, message: '请选择产品', trigger: 'blur' }
        ],
        manager: [
          { required: true, message: '请输入负责人', trigger: 'blur' }
        ],
        num: [
          { required: true, message: '请输入数量', trigger: 'blur' }
        ]
      }
    }
  },
  props: {
    productionRecordId: Number,
    productId: Number
  },
  computed: {
    title() {
      return this.currentID ? '编辑批次' : '新增批次'
    }
  },
  created() {
    this.debounceRefresh = debounce(300, this.refresh)
    this.debounceSubmit = debounce(300, this.batchSubmit)
  },
  methods: {
    // onDelDynamicForm(index) {
    //   this.batchForm.domains.splice(index, 1)
    // },
    // onAddDynamicForm() {
    //   this.batchForm.domains.push({
    //     key: ++this.uid,
    //     name: '',
    //     number: 0
    //   })
    // },
    hanleResetFormVals() {
      this.$set(this, 'batchForm', createForm())
      this.$refs.refbatchForm.clearValidate()
      this.batchFormVisible = false
    },
    handleSelectionChange(selection) {
      this.selectionID = selection.map(_ => _.id)
    },
    handleRemoveAll() {
      delBatchmanageList(this.selectionID).then(res => {
        if (res.status === 1) {
          this.$message.success('删除成功')
          this.getBatchmanageListData()
        } else {
          this.$message.error(res.msg)
          return false
        }
      })
    },
    // 分页
    handleSizeChange(val) {
      this.size = val
      this.getBatchmanageListData()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getBatchmanageListData()
    },
    // 删除批次
    batchDel(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteBatchmanageDel(id).then(res => {
            if (res.status === 1) {
              this.$message.success('删除批次成功')
              this.getBatchmanageListData()
            } else {
              this.$message.error(res.msg)
              return false
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 提交表单
    batchSubmit() {
      this.$refs.refbatchForm.validate(valid => {
        if (!valid) return false
        const batchItems = this.currentID
          ? postBatchmanageEdit
          : putBatchmanageAdd

        const options = {
          batchCode: this.batchForm.batchCode,
          manager: this.batchForm.manager,
          startDate: this.batchForm.startDate,
          endDate: this.batchForm.endDate,
          productId: this.batchForm.productId,
          num: this.batchForm.num,
          productionRecordId: this.productionRecordId,
          id: this.currentID || undefined
        }

        // if (this.isAdd) {
        //   options.productIds = this.batchForm.productIds
        //   options.nums = this.batchForm.nums
        // } else {
        //   options.productId = this.batchForm.domains[0].name
        //   options.num = this.batchForm.domains[0].number
        // }

        batchItems(options).then(res => {
          if (res.status === 1) {
            this.currentID ? this.$message.success('编辑批次成功') : this.$message.success('新增批次成功')
            this.getBatchmanageListData()
            this.batchFormVisible = false
          } else {
            this.$message.error(res.msg)
            return false
          }
        })
      })
    },
    // 打开表单层
    batchPopup(id) {
      this.$set(this, 'batchForm', createForm())
      this.isAdd = !id

      this.batchFormVisible = true
      if (this.isAdd) {
        this.batchForm.batchCode = new Date().getTime()
        this.currentID = null
        getProductDetail(this.productId).then(res => {
          this.batchForm.productId = res.data.id
          this.batchForm.productName = res.data.productName
        })
      } else {
        this.isDisabled = true
        getBatchmanageDetail(id).then(res => {
          if (res.status === 1) {
            this.currentID = id
            this.batchForm.batchCode = res.data.batchCode
            this.batchForm.startDate = moment(res.data.startDate).format('YYYY-MM-DD')
            this.batchForm.endDate = moment(res.data.endDate).format('YYYY-MM-DD')
            this.batchForm.productId = res.data.productId
            this.batchForm.num = res.data.num
            this.batchForm.productName = res.data.productName
            // this.batchForm.domains[0].name = res.data.productId
            // this.batchForm.domains[0].number = res.data.num
            this.batchForm.manager = res.data.manager
            this.batchForm.productionRecordId = res.data.productionRecordId
            this.productionRecordId = res.data.productionRecordId
            this.isDisabled = false
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    // 获取商品编码并赋值
    setProductNumber(val) {
      let selectObj = null
      for (let i = 0; i < this.productList.length; i++) {
        selectObj = this.productList.find(item => {
          return item.value === val
        })
      }
      this.batchForm.batchCode = selectObj.barcode.substring(selectObj.barcode.length - 4) + new Date().getTime()
    },
    // 打开关键控制点
    batchControlPoint(id) {
      this.batchControlPointVisible = true
      this.batchId = id
    },
    // 打开检查项
    batchCheckPoint(id) {
      this.batchCheckVisible = true
      this.batchId = id
    },
    // 打开二维码列表
    qrCodePopup(id) {
      this.batchId = id
      getBatchmanageDetail(id).then(res => {
        if (res.status === 1) {
          this.batchCode = res.data.batchCode
          this.barcode = res.data.barcode
          this.qrCodePopupVisible = true
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 检索
    search() {
      this.getBatchmanageListData()
    },
    // 刷新数据表格
    refresh() {
      this.getBatchmanageListData()
      this.$message.success('数据刷新成功')
    },
    // 获取批次列表
    getBatchmanageListData() {
      this.loading = true
      getBatchmanageProductList({
        page: this.page,
        size: this.size,
        keywords: this.keywords,
        productId: this.productId
      }).then(res => {
        if (res.status === 1) {
          this.total = res.data.total
          this.tableData = res.data.rows
        } else {
          this.$message.error(res.msg)
        }

        this.loading = false
      })
    },
    // 获取商品列表
    getGoodsListData() {
      getProductList({
        page: 1,
        size: 1000,
        productState: 1
      }).then(res => {
        if (res.status === 1) {
          const arr = []
          for (let i = 0; i < res.data.rows.length; i++) {
            arr.push({ label: res.data.rows[i].productName, value: res.data.rows[i].id, barcode: res.data.rows[i].barcode })
          }
          this.productList = arr
        } else {
          this.$message.error(res.msg)
        }
      })
    }
  },
  mounted() {
    this.getBatchmanageListData()
    this.getGoodsListData()
    getBatchmanageProduct(this.productId).then(res => {
      if (res.status === 1) {
        this.addBtnShow = true
      } else {
        this.addBtnShow = false
      }
    })
  },
  filters: {
    format(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss')
    },
    formatDate(value) {
      return moment(value).format('YYYY-MM-DD')
    }
  }
}
</script>
<style lang="scss" scoped>
.product-select-wrap {
  position: relative;
}
</style>
